import { createContext, useContext, useEffect, useState } from "react";
import { getT, translations } from "./translations";

const STORAGE_KEY = "superstateLanguage";
const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "es" || saved === "en" ? saved : "en";
  });

  const setLang = (l) => {
    if (l !== "en" && l !== "es") return;
    setLangState(l);
    try {
      localStorage.setItem(STORAGE_KEY, l);
    } catch (_) { /* ignore */ }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = getT(lang);
  return (
    <LangContext.Provider value={{ lang, setLang, t, translations }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
}
